<template>
    <div class="webtab-button-wrapper">
        <div class="webtab-trigger-button" @click="toggleWebTabList">
            <span class="material-icons webtab-icon">tab</span>
        </div>

        <!-- Custom Dropdown -->
        <div v-if="visible" class="custom-dropdown" @click.stop>
            <div class="dropdown-content">
                <!-- Web Tab'lar -->
                <div
                    v-for="tab in webTabs"
                    :key="tab._id"
                    class="webtab-item"
                    @click="selectWebTab(tab)"
                    v-tippy
                    :content="tab.description || tab.name"
                    data-tippy-placement="bottom"
                    data-tippy-theme="light-border"
                >
                    <div class="webtab-icon-wrapper">
                        <span class="material-icons list-icon" :style="{ color: tab.iconColor || '#6b727d' }">
                            {{ tab.icon || 'tab' }}
                        </span>
                    </div>
                    <span class="webtab-name">{{ tab.name }}</span>
                </div>
            </div>
            <div class="divider"></div>
            <div class="webtab-item create-new" @click="createNewWebTab">
                <div class="plus-icon-wrapper">
                    <span class="plus-icon">+</span>
                </div>
                <span class="webtab-name">{{ $t("message.webTabCreateNew") }}</span>
            </div>
        </div>

        <!-- Backdrop -->
        <div v-if="visible" class="dropdown-backdrop" @click="visible = false"></div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import SYSTEM_PUBSUB from "../../utils/systemPubSub";

export default {
    name: "WebTabButton",
    data() {
        return {
            visible: false,
        };
    },
    computed: {
        ...mapGetters({
            webTabs: "webtabs/getToolbarWebTabs",
            getWebTabUrl: "webtabs/getWebTabUrl",
        }),
    },
    methods: {
        toggleWebTabList() {
            this.visible = !this.visible;
        },
        selectWebTab(tab) {
            this.visible = false;

            if (tab.toolbarMode === "parent") {
                // Direkt sayfaya git (menüdeki gibi)
                this.$router.push(`/webtab/${tab._id}`);
            } else {
                // Popup modda aç
                this.openWebTabInPopup(tab);
            }
        },
        openWebTabInPopup(tab) {
            // URL'yi store getter ile generate et
            const url = this.getWebTabUrl(tab);

            if (!url) {
                this.$message.error("Web sekmesi URL'si oluşturulamadı");
                return;
            }

            if (tab.keepAlive) {
                // Keep-alive modda aç
                SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.OPEN_KEEP_ALIVE_WIDGET, {
                    webTabId: tab._id,
                    title: tab.name,
                    fullScreen: false,
                    webTab: tab,
                });
            } else {
                // Normal popup modda aç
                SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.OPEN_WIDGET, {
                    title: tab.name,
                    url,
                    fullScreen: false,
                    mode: "url",
                    html: "",
                });
            }
        },
        createNewWebTab() {
            this.visible = false;
            this.$router.push("/integrations/webtabs/new");
        },
    },
};
</script>

<style lang="scss" scoped>
.webtab-button-wrapper {
    position: relative;
    display: inline-block;
}

.webtab-trigger-button {
    width: 32px;
    height: 32px;
    border-radius: 6px;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    border: none;
    padding: 0;

    &:hover {
        background: var(--color-bg-neutral-hover);
    }

    .webtab-icon {
        font-size: 18px;
        color: #3A3F48;
    }
}

.custom-dropdown {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    z-index: 1055;
    min-width: 177px;
    max-width: 250px;
    width: max-content;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .dropdown-content {
        max-height: 220px;
        overflow-y: auto;
        padding: 4px 4px 0 4px;
        border-radius: 12px;

        &::-webkit-scrollbar {
            width: 3px;
        }

        &::-webkit-scrollbar-track {
            background: transparent;
        }

        &::-webkit-scrollbar-thumb {
            background: #c9c9c9;
            border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb:hover {
            background: #b0b0b0;
        }
    }

    .webtab-item {
        display: flex;
        align-items: center;
        gap: 7px;
        padding: 7px;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.2s ease;
        margin-bottom: 2px;

        &:last-child {
            margin-bottom: 0;
        }

        &:hover {
            background: #f5f5f5;
        }

        .webtab-icon-wrapper {
            width: 18px;
            height: 18px;
            min-width: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;

            .list-icon {
                font-size: 18px;
            }
        }

        .webtab-name {
            color: #1a1d1f;
            font-size: 12px;
            font-weight: 500;
            font-family: Inter, sans-serif;
            flex: 1;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        &.create-new {
            margin: 0 4px 4px 4px;
            justify-content: center;

            .plus-icon-wrapper {
                width: 18px;
                height: 18px;
                min-width: 18px;
                border-radius: 4px;
                background: #e8e8ea;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;

                .plus-icon {
                    font-size: 15px;
                    color: #3a3f48;
                    font-weight: 500;
                    line-height: 1;
                }
            }

            .webtab-name {
                color: #3a3f48;
            }

            &:hover {
                background: #f5f5f5;

                .plus-icon-wrapper {
                    background: #d9d9db;
                }
            }
        }
    }

    .divider {
        height: 1px;
        background: #e8e8ea;
        margin: 4px 0;
        flex-shrink: 0;
    }
}

.dropdown-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1054;
    background: transparent;
}
</style>

